module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[5]),
      expression: "getScreenSize < 2 && !delayedLoading[5]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[0]) ? _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/Compression')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getUnsavedLocalSettings.download.downlzip),
      callback: function($$v) {
        _vm.$set(_vm.getUnsavedLocalSettings.download, "downlzip", $$v)
      },
      expression: "getUnsavedLocalSettings.download.downlzip"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/download/No compression'),
      "value": parseInt(0)
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/download/Zip compression'),
      "value": parseInt(1)
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/download/Noise')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsDevice.valsel), function(value) {
    return _c('el-col', {
      key: value,
      attrs: {
        "sm": 6,
        "lg": 4
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": value
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": "",
        "off-value": ""
      },
      model: {
        value: (_vm.getUnsavedLocalSettings.download.downlnoise[value]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.download.downlnoise, value, $$v)
        },
        expression: "getUnsavedLocalSettings.download.downlnoise[value]"
      }
    })], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-collapse-item', {
    class: _vm.getClass('weather'),
    attrs: {
      "title": _vm.$l('settings/download/Weather')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsWeather.valsel), function(item) {
    return (item.enabled) ? _c('el-col', {
      key: item.name,
      attrs: {
        "sm": 12,
        "lg": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": item.name
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getUnsavedLocalSettings.download.downlweath[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.download.downlweath, item.name, $$v)
        },
        expression: "getUnsavedLocalSettings.download.downlweath[item.name]"
      }
    })], 1)], 1) : _vm._e()
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/download/Global Values')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsSpecval.global), function(item) {
    return _c('el-col', {
      key: item,
      attrs: {
        "sm": 6,
        "lg": 4
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": item
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getUnsavedLocalSettings.download.downlGlobal[item]),
        callback: function($$v) {
          _vm.$set(_vm.getUnsavedLocalSettings.download.downlGlobal, item, $$v)
        },
        expression: "getUnsavedLocalSettings.download.downlGlobal[item]"
      }
    })], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[4]) ? _c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/download/Special values')
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "sm": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/Audio')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.getUnsavedLocalSettings.download.audio),
      callback: function($$v) {
        _vm.$set(_vm.getUnsavedLocalSettings.download, "audio", $$v)
      },
      expression: "getUnsavedLocalSettings.download.audio"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/Video')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.getUnsavedLocalSettings.download.video),
      callback: function($$v) {
        _vm.$set(_vm.getUnsavedLocalSettings.download, "video", $$v)
      },
      expression: "getUnsavedLocalSettings.download.video"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/Markers')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.getUnsavedLocalSettings.download.markers),
      callback: function($$v) {
        _vm.$set(_vm.getUnsavedLocalSettings.download, "markers", $$v)
      },
      expression: "getUnsavedLocalSettings.download.markers"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57047924","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/Download.vue
// module id = 458
// module chunks = 1